import { PlayResponse } from '../../types';
import { getTopSlotWinTypes } from './helper';

export function getLocalBallSpinPlayData(): PlayResponse {
    return {
        round: 'uid',
        step: 'uid',
        balance: 100000,
        resp: {
            win: true,
            top_slot: {
                types: getTopSlotWinTypes(),
                type: 'BALL_SPIN',
                multipliers: ['1', '2', '3', '4', '5', '7', '10', '15', '20', '25', '50'],
                multiplier: '7'
            },
            color: 'YELLOW', // цвет вытянутого шара, null - если не вытянула
            bonus_game: 'BALL_SPIN', //бонуска
            ball_spin_params: {
                multipliers_left: ['5', '10', '20'],
                multipliers_right: ['25', '50', '100']
            },
            ball_spin_result: {
                multiplier_left: '5',
                multiplier_right: '25',
                side: 'LEFT'
            },
            win_amount: 1234578,
            win_type: 'MEGA', //DEFAULT, BIG, SUPER, EPIC, MEGA, NONE
            ball_type: ''
        },
        final: true
    };
}
